module.exports = "pegasus_template/assets/tech/realty/105.png";